import * as React from "react";
import { SVGProps, Ref, forwardRef } from "react";
const SvgComponent = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="1em"
        height="1em"
        fill="none"
        viewBox="0 0 16 16"
        ref={ref}
        {...props}
    >
        <path
            fill="var(--sds--ursa-icons--inner-shape-color, transparent)"
            d="M8 5.2a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5m.65 3.05a.65.65 0 0 0-1.3 0v2.25a.65.65 0 1 0 1.3 0z"
        />
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="M2 8a6 6 0 1 1 12 0A6 6 0 0 1 2 8m5.25-2.05a.75.75 0 1 1 1.5 0 .75.75 0 0 1-1.5 0M8 7.6a.65.65 0 0 1 .65.65v2.25a.65.65 0 1 1-1.3 0V8.25A.65.65 0 0 1 8 7.6"
            clipRule="evenodd"
        />
    </svg>
);
const ForwardRef = forwardRef(SvgComponent);
export default ForwardRef;
